// extracted by mini-css-extract-plugin
var _1 = "_blankCard-module__container";
export { _1 as "container" }
